import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LayersIcon from '@mui/icons-material/Layers';
import SummarizeIcon from '@mui/icons-material/Summarize';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";


function MainListItems(props){
    const navigate = useNavigate()
    const {t, i18n} = useTranslation()

    const [isHome, setIsHome] = useState(false)
    const [orders, setOrders] = useState(false)
    const [delivery, setDelivery] = useState(false)

    function changeValues(val){
        switch (val){
            case 1:
                navigate('/dashboard/')
                break;
            case 2:
                navigate('/orders/')
                break;
            case 3:
                navigate('/add-delivery/')
                break;
            default:
                return false
        }
    }

    useEffect(()=>{
        if(window.location.pathname === '/dashboard/'){
            setIsHome(true)
            setOrders(false)
            setDelivery(false)
        }else if(window.location.pathname === '/orders/'){
            setIsHome(false)
            setOrders(true)
            setDelivery(false)
        }else if(window.location.pathname === '/add-delivery/'){
            setIsHome(false)
            setOrders(false)
            setDelivery(true)
        }
    }, [])



    return <div className={'menu'}>
        <ListItemButton className={isHome ? 'active' : ''}  onClick={()=>changeValues(1)} >
            <ListItemIcon>
                <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary={"Bosh sahifa"}/>
        </ListItemButton>
        <ListItemButton className={orders ? 'active' : ''}  onClick={()=>changeValues(2)} >
            <ListItemIcon>
                <LayersIcon />
            </ListItemIcon>
            <ListItemText primary={"Buyurtmalar"}/>
        </ListItemButton>
        <ListItemButton className={delivery ? 'active' : ''}  onClick={()=>changeValues(3)} >
            <ListItemIcon>
                <LocalShippingIcon />
            </ListItemIcon>
            <ListItemText primary={"Yetkazib berish"}/>
        </ListItemButton>
    </div>
}

export default MainListItems
